/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkerJobStatusFromJSON, WorkerJobStatusToJSON, WorkerJobTypeFromJSON, WorkerJobTypeToJSON, } from './';
export function WorkerJobRepresentationFromJSON(json) {
    return WorkerJobRepresentationFromJSONTyped(json, false);
}
export function WorkerJobRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        type: WorkerJobTypeFromJSON(json['type']),
        status: WorkerJobStatusFromJSON(json['status']),
        percentDone: json['percentDone'],
    };
}
export function WorkerJobRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        type: WorkerJobTypeToJSON(value.type),
        status: WorkerJobStatusToJSON(value.status),
        percentDone: value.percentDone,
    };
}
